<template>
    <v-card>
        <v-card-title>Change Schedule Date</v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-date-picker full-width v-model="newDate" no-title></v-date-picker>
                </v-col>
                <v-col>
                    <div v-if="!summaryLoading">
                    
                        <v-row>
                            <v-col>
                                <v-sheet>
                                    <div>
                                        <div>Total Quantity</div>
                                        <div class="text-h3">{{ formatNumber(totalQuantity) }}</div>
                                    </div>
                                </v-sheet>
                            </v-col>
                            <v-col>
                                <v-sheet class="d-flex flex-row">
                                    <div>
                                        <div>Date Lock State</div>
                                        <div class="text-h3">
                                            <span class="error--text" v-if="summary.is_locked_date">Locked</span>
                                            <span class="success--text" v-else>Open</span>
                                        </div>
                                    </div>
                                </v-sheet>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th>Cast Type</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(d, i) in summary.cast_types_total" :key="i">
                                            <td>{{ d.cast_type }}</td>
                                            <td>{{ formatNumber(d.quantity) }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="grey lighten-3 font-weight-bold">
                                            <td>Total</td>
                                            <td>{{ formatNumber(totalQuantity) }}</td>
                                        </tr>
                                    </tfoot>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row>
                            <v-col class="d-flex justify-center">
                                <v-progress-circular indeterminate size="50" color="primary"/>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-combobox
                        dense
                        label="Remarks"
                        placeholder="Why do you want to change the date?"
                        v-model="remarks"
                        :items="remarksList"
                        outlined
                        prepend-inner-icon="mdi-comment-text-outline"
                        hide-details
                        clearable
                        append-icon=""
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="handleSubmit">submit</v-btn>
            <v-btn depressed @click="$emit('cancel')">cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import {  formatNumber } from "accounting";
import summary from "./../../services/scheduling/summary";
import { getTotal } from "../../utils/accounting";
import scheduleService from "../../services/scheduling/schedule";

export default {
    props: {
        date: String,
        scheduleId: Number
    },
    data() {
        return {
            newDate: null,
            remarks: null,
            summary: {},
            summaryLoading: false,
            loading: false,
            changeDateLoading: false,
            remarksList: [
                "Customer location is not compatible with the delivery date",
                "Customer has changed the delivery date",
                "Production capacity is not enough",
                "Shortage of raw materials",
                "Machine breakdown",
                "Customer did not settle the payment",
                "Other"
            ]
        }
    },
    computed: {
        totalQuantity() {
            return getTotal(this.summary.cast_types_total, "quantity");
        }
    },
    watch: {
        newDate() {
            this.fetchSummary();
        }
    },
    methods: {
        formatNumber,
        getTotal,
        fetchSummary() {
            this.summaryLoading = true;
            summary.summary(this.newDate).then(res => {
                this.summary = res.data;
            }).finally(() => {
                this.summaryLoading = false;
            })
        },
        handleSubmit() {
            this.changeDateLoading = true;
            scheduleService.changeDate(this.scheduleId, this.newDate, this.remarks).then(() => {
                this.$emit("submit");
            }).finally(() => {
                this.changeDateLoading = false;
            })
        }
    },
    created() {
        this.newDate = this.date
    }
}
</script>

<style>

</style>